import React, { useState, useEffect, useReducer, useMemo } from 'react'
import axios from 'axios'
import List from './list'

const receivable = props => {
  const [particularName, setParticularName] = useState('');
  const [amount, setAmount] = useState('');

  const receivableListReducer = (state, action) => {
    switch (action.type) {
      case 'ADD':
        return state.concat(action.payload);
      case 'SET':
        return action.payload;
      case'REMOVE':
        return state.filter((todo) => todo.id !== action.payload);
      default:
          return state;
    }
  }
  
  const [receivableList, dispatch] = useReducer(receivableListReducer, [])

  useEffect(() => {
    axios
      .get('https://reacthookstodoapp.firebaseio.com/receivable.json')
      .then(result => {
        // console.log(result);
        const data = result.data;
        const lists = [];
        for (const key in data) {
          lists.push({id: key, name: data[key].name, amount: data[key].amount})
        }
        dispatch({ type: 'SET', payload: lists })
      })
      .catch(err =>{
        console.log(err);
      })

      return () => {
        
      }
  }, []);

  const inputChangeHandler = event => {
    setParticularName(event.target.value)
  }
  const amountChangeHandler = event => {
    setAmount(event.target.value)
  }

  const todoAddHandler = () => {
    if (!particularName || !amount) {
      return false;
    }
    axios
      .post('https://reacthookstodoapp.firebaseio.com/receivable.json', {name: particularName, amount: amount})
      .then(res => {
        const item = {id: res.data.name, name: particularName, amount: amount};
        dispatch({ type: 'ADD', payload: item })
        setParticularName('')
        setAmount('')
        props.setCount(props.count + 1)
      })
      .catch(err =>{
        console.log(err);
      })
  }

  const todoRemoveHandler = todoId => {
    axios
      .delete(`https://reacthookstodoapp.firebaseio.com/receivable/${todoId}.json`, {name: particularName})
      .then(res => {
        dispatch({ type: 'REMOVE', payload: todoId })
        props.setCount(props.count + 4)
      })
      .catch(err =>{
        console.log(err);
      })
    
  }

  return (
    <React.Fragment>
      <div style={{marginTop: '5px', padding: '5px' }}>
        <h3 style={{textAlign: 'center',color: '#2e8bcc'}}><span style={{borderBottom: '2px solid #2e8bcc'}}>RECEIVABLE</span></h3>
        <input 
            type="text"
            placeholder="Particular"
            onChange={inputChangeHandler}
            value={particularName}
            style={{height: '24px', marginRight: '2px'}}
          />
        <input 
            type="text"
            placeholder="Amount"
            onChange={amountChangeHandler}
            value={amount}
            style={{height: '24px'}}
          />
          <button type="button" onClick={todoAddHandler} className="btn btn-success">Add</button>
          <br />
          { useMemo(
              () => (
                receivableList.length > 0 ? <List items={receivableList} onClick={todoRemoveHandler} /> : <p className="none">None</p>
              ),
              [receivableList]
            )
          }
      </div>
    </React.Fragment>
  )
 
}

export default receivable;


// WEBPACK FOOTER //
// ./src/components/Receivable/index.js